import React from 'react';
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { TimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useRecoilState } from 'recoil';
import { SetDoctorSessionTiming } from "../../../../recoil/atom/SetDoctorSessionTiming";
import { MainButtonInput } from "../../../../mainComponent/mainButtonInput";
import { MainInput } from '../../../../mainComponent/mainInput';
import { MainSelect } from '../../../../mainComponent/mainSelect';
import moment from 'moment';
import SessionApi from "../../../../services/SessionApi";
import { useForm } from 'react-hook-form';

function SetTiming(props) {
    const { doctorId, clinicId, day, } = props;
    const [ error, setError] = useState("");
    const [ feesError, setFeesError] = useState("");
    const [ coilSessionTimining, setCoilSessionTimining] = useRecoilState(SetDoctorSessionTiming)
    const [ selectedSlots, setSelectedSlots] = useState([])
    const { setSessionTimeData } = SessionApi()
    const [ sessionTime, setSessionTime] = useState({
        clinicId: clinicId,
        doctorId: doctorId,
        timeSlot: 20,
        fees: "",
        day: day,
        Appointment: " "
    })
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setSessionTime({ ...sessionTime, [name]: value });
        setValue(name, value)
    };

    const handleChange = (event, index) => {
        const { name, value } = event.target;
        setSessionTime({ ...sessionTime, [name]: value });
        let newState = [...selectedSlots]
        newState[index]["status"] = !selectedSlots[index]["status"]
        setSelectedSlots(newState);
    }
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    
    const handleToTimeSelection = (time) => {
        setSessionTime(sessionTime => {
            return {
                ...sessionTime,
                ['toTime']: time
            }
        })
        const interval = sessionTime.timeSlot;
        const fromTime = sessionTime.fromTime;

        const startTime = moment(fromTime, "HH:mm");
        const allTimes = [];
        while (startTime < time) {
            allTimes.push({ time: startTime.format("HH:mm"), status: true }); //Push times
            startTime.add(interval, 'minutes');//Add interval of selected minutes
        }
        setSelectedSlots(allTimes)
    }


    const handleFromTimeSelection = (time) => {
        setSessionTime(sessionTime => {
            return {
                ...sessionTime,
                ['fromTime']: time
            }
        })
    }

    function handleTimeClick(e) {
        e.preventDefault();
        const setTimeData = {
            clinicId: clinicId,
            doctorId: sessionTime.doctorId,
            fromTime: sessionTime.fromTime,
            toTime: sessionTime.toTime,
            timeSlot: sessionTime.timeSlot,
            showSelectedSlots: selectedSlots.filter((e) => e.status === true),
            Appointment: "InClinicAppointment",
            fees: sessionTime.fees,
            day: sessionTime.day
        }
        if (sessionTime.fromTime < sessionTime.toTime) {
            setSessionTimeData(setTimeData)
                .then(res => {
                    let setTime = {}
                    setTime[sessionTime.day] = [res.data]
                    setCoilSessionTimining({ ...coilSessionTimining, ...setTime })
                    props.onSubmit();
                });
        } else {
            setError("Please enter valid time");
        }
        if (sessionTime.fees === '') {
            setFeesError('Enter Fees')
        }
        else {
            props.onSubmit()
        }
    }

    return (
        <div className="col-lg-12">
            {/* <form onSubmit={handleSubmit(handleTimeClick)}> */}
            <h5>{day}</h5>
            <div className="row">
                <div className="col-lg-6">
                    <label className="font_weight">Select Time Slot</label>
                    <MainSelect name="timeSlot" defaultValue="15 min" onChange={handleInputChange} value={sessionTime.timeSlot} >
                        <option selected="selected" value={15}> 15 min</option>
                        <option value={20}> 20 min</option>
                        <option value={30}> 30 min</option>
                    </MainSelect>
                </div>

                <div className="col-lg-6">
                    <label className="font_weight">Clinic Fees</label>
                    <MainInput
                        type="text"
                        name="fees"
                        onChange={handleInputChange}
                        value={sessionTime.fees}
                        placeholder="Enter fees" >
                    </MainInput>
                    {feesError && <span className="validation">{feesError}</span>}
                </div>
            </div>

            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <div className="k-widget k-timepicker">
                            <div>
                                <label className="font_weight">
                                    From Time
                                </label>
                            </div>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <TimePicker
                                    renderInput={(props) => <TextField {...props} />}
                                    value={sessionTime.fromTime}
                                    name="fromTime"
                                    ampm={false}
                                    minutesStep={5}
                                    onChange={handleFromTimeSelection}
                                />
                            </LocalizationProvider>
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-group">
                        <div>
                            <label className="font_weight">
                                To Time
                            </label>
                        </div>
                        <div className='width_timepicker'>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <TimePicker
                                    renderInput={(props) => <TextField {...props} />}
                                    value={sessionTime.toTime}
                                    ampm={false}
                                    name="toTime"
                                    minutesStep={5}
                                    onChange={handleToTimeSelection}
                                />
                            </LocalizationProvider>
                        </div>
                        {error && <span className="validation">Please enter valid time</span>}
                    </div>
                </div>
            </div>

            {selectedSlots ?
                <section className="borderSlots">
                    {selectedSlots.map((item, index) => (
                        <div key={index}>
                            <div
                                id="ck-button"
                                style={item.status === false ?
                                    { backgroundColor: 'rgb(228, 217, 217)', color: 'black' }
                                    : null}
                            >
                                <label>
                                    <input
                                        onChange={(event) => handleChange(event, index)}
                                        type="checkbox"
                                        checked={item.status ? true : false}
                                        value="1"
                                        name="selectedSlots"
                                    />
                                    <span>{item.time}</span>
                                </label>
                            </div>
                        </div>
                    ))}
                </section>
                : null}

            <div className="text-center  p-2 add_top_30">
                <MainButtonInput onClick={handleTimeClick}>Set</MainButtonInput>
            </div>
            {/* </form> */}
        </div>
    )
}
export { SetTiming }
